import { TableApiInterface } from "@/types/page/table";
import { getDateAndTime } from "@/utils/date";

export const processConclusionsList = (table: TableApiInterface) => {
    table.titles = table.titles.map(title => {
        if (title.id === 'datetime') {
            title.visible = false;
        }

        return title;
    });

    const titles = [
        { id: 'name', name: 'Дата и время', visible: true },
        ...table.titles,
    ]

    const rows = table.rows.map(row => {
        return {
            name: getDateAndTime(row.datetime),
            ...row,
        }
    });

    table.titles = titles;
    table.rows = rows;

    return table;
}